import { defineAsyncComponent, markRaw } from "vue";

export const useAsyncComponent = (component) => markRaw(defineAsyncComponent(component))
